import React from "react";

type Props = {
  message: string;
  actionType?: "seller" | "admin" | "no";
};

export const StatusMessage = ({ message, actionType }: Props) => {
  return (
    <div className="col-12">
      <div className={`status-message status-message--${actionType || "no"}_action`}>
        <span>{message}</span>
      </div>
    </div>
  );
};
